import React, { Component } from "react";
import { connect } from "react-redux";
import { savePelletsStateToCache, restorePelletsStateFromCache } from "Actions";
import { fetchInfinitePellets } from "Thunks";

import PelletComponent from "./PelletComponent";

class PelletContainer extends Component {
  componentDidMount() {
    const { offset, limit, fetchInfinitePellets, loggedAs } = this.props;
    if (loggedAs === "CLIENT") {
      return null;
    }

    fetchInfinitePellets({ limit, offset });
  }

  componentDidUpdate(prevProps) {
    const {
      limit,
      selectedClient,
      savePelletsStateToCache,
      restorePelletsStateFromCache,
      fetchInfinitePellets
    } = this.props;

    if (prevProps.selectedClient !== this.props.selectedClient) {
      if (selectedClient) {
        savePelletsStateToCache();
        fetchInfinitePellets({
          limit,
          offset: 0,
          clientId: selectedClient.id
        });
      } else {
        restorePelletsStateFromCache();
      }
    }
  }

  loadMore = () => {
    const {
      offset,
      limit,
      loggedAs,
      selectedClient,
      fetchInfinitePellets
    } = this.props;
    if (loggedAs === "CLIENT") {
      return null;
    }

    const clientId = selectedClient && selectedClient.id;
    fetchInfinitePellets({ limit, offset, clientId });
  };

  render() {
    const { pellets, fetching, hasMore } = this.props;

    return (
      <PelletComponent
        pellets={pellets}
        fetching={fetching}
        loadMore={this.loadMore}
        hasMore={hasMore}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  pellets: state.pellets.items,
  fetching: state.pellets.fetching,
  selectedClient: state.pellets.pelletSelectedOrg,
  hasMore: state.pellets.hasMoreItems,
  offset: state.pellets.offset,
  limit: state.pellets.limit
});

const mapDispatchToProps = dispatch => ({
  fetchInfinitePellets: params => dispatch(fetchInfinitePellets(params)),
  savePelletsStateToCache: () => dispatch(savePelletsStateToCache()),
  restorePelletsStateFromCache: () => dispatch(restorePelletsStateFromCache())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PelletContainer);



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Pellet/PelletContainer.js